module.exports = __webpack_public_path__ + "img/snackLogo@2.7e25c9a.png";